module.exports = __webpack_public_path__ + "lp/img/next-brand.c5731095.svg";